import './ImageInput.scss';
import * as React from 'react';
import LoadingEllipsis from '../LoadingSpinner';

interface PropsType {
  label?: string;
  automation?: string;
  imageDataUrl: string;
  allowDeletion?: boolean;
  loading: boolean;
  uploadImage: (imageData) => void;
  onDelete?: () => void;
}
interface StateType {
  image: string;
}
export default class ImageInput extends React.Component<PropsType, StateType> {
  private input;
  constructor(props) {
    super(props);
  }

  private handleOnChange(e) {
    if (e.target.files[0]) { this.props.uploadImage(e.target.files[0]); }
  }

  public render() {
    let label = null;
    if (this.props.label) {
      label = (
        <span
          className="Label"
          data-automation={this.props.automation + '-label'}
        >
          {this.props.label}
        </span>
      );
    }

    const baseClasses = ['Controlled', 'Input', 'FilePreview'];
    return (
      <div className={baseClasses.join(' ')}>
        {label}
        <div className={'imageInputContainer'}>
          <input
            ref={(input) => {
              this.input = input;
            }}
            type="file"
            accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF"
            className={'fileInput'}
            data-automation={this.props.automation}
            onChange={this.handleOnChange.bind(this)}
          />
          {this.props.loading && <LoadingEllipsis />}
          <a className="image" onClick={() => { this.input.click(); }}
            style={{ backgroundImage: `url(${this.props.imageDataUrl})` }}></a>
          {this.props.allowDeletion && <div className="Clear" onClick={() => this.props.onDelete()}></div>}
        </div>
      </div>
    );
  }
}
